export default __webpack_public_path__ + "static/worksans-regular-webfont-bd6b3d492e882fdaedd9defae0dc69b3.woff";